import { format } from "date-fns";

function convertIsoToJsDate(isoString) {
    const date = new Date(isoString);

    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();

    return new Date(year, month, day);
}

const formatDate = (dateString, includeTime = false) => {
    if (!dateString) return "Indefinido";

    const date = convertIsoToJsDate(dateString);
    return format(date, includeTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy");
};

export const onlyDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return "";
    return dateString.slice(0, 10);
};

const shortenName = (fullName) => {
    if (fullName && typeof fullName === 'string') {
        const nameParts = fullName.trim().split(' ');

        const firstNameInitial = nameParts[0].charAt(0).toUpperCase();
        const lastNameInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();

        return firstNameInitial + lastNameInitial;
    }
    return '';
};

const convertImageToBase64 = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);

            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        img.onerror = reject;
        img.src = url;
    });
};

const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join('');
    }
    const bigint = parseInt(hex, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

export default {
    formatDate,
    shortenName,
    convertIsoToJsDate,
    onlyDate,
    convertImageToBase64,
    hexToRgb
};
